import React, { Component } from 'react'
import { connect } from 'react-redux';

import ImmutablePropTypes from 'react-immutable-proptypes';
import GameListItem from './GameListItem'

import { toggleFavouriteGame } from './../actions/actions'

class GameList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };

    this.toggleFavouriteGame = this.toggleFavouriteGame.bind(this);
  }

  toggleFavouriteGame(game) {
    this.props.toggleFavouriteGame(game)
  }

  render() {
    return (
      <ul className="list-group col-md-12" style={{ paddingRight: 0 }}>
        {this.props.games.map((game, i) =>
          <GameListItem game={game} key={i} config={this.props.config} urlLaunchOptions={this.props.urlLaunchOptions} launchOptions={this.props.launchOptions} toggleFavourite={this.toggleFavouriteGame} />
        )}
      </ul>
    )
  }
}

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => {
  return {
    toggleFavouriteGame: game => dispatch(toggleFavouriteGame(game))
  };
};

GameList.propTypes = {
  config: ImmutablePropTypes.map,
  games: ImmutablePropTypes.list,
  launchOptions: ImmutablePropTypes.map,
  urlLaunchOptions: ImmutablePropTypes.map
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GameList);


// WEBPACK FOOTER //
// ./src/components/GameList.js